export default __webpack_public_path__ + "static/media/ComicSansMS-Regular.2be4a49a.ttf";